//@ts-ignore
import "./assets/scss/style.scss";
//@ts-ignore
import "./tailwind.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store, { useAppDispatch } from "./redux/redux";
import { Route, Routes } from "react-router-dom";
import Web from "./_Web/Web";
import UserController from "./assets/Controllers/UserController";
import { initAxios } from "./assets/Services/axios";
import { initi18next } from "./assets/Services/i18next";
import OrderController from "./assets/Controllers/OrderController";
import { ToastContainer } from "react-toastify";
import { apiErrorToast } from "./assets/Utils/errors";
import { initTagManager } from "./assets/Services/tagmanager";
import Modal from "./_Web/components/Modal/Modal";
import CookiesBanner, {
  initCookies,
} from "./_Web/components/CookiesBanner/CookiesBanner";
import { Redirect } from "./assets/Utils/app";
import { useEffect, useRef } from "react";
import { debounce } from "lodash";
import { setResizeHook } from "./redux/slices/appSlice";
import openAuthModal from "./_Web/components/Auth/Auth";
import OfferController from "./assets/Controllers/OfferController";
import FavoritesController from "./assets/Controllers/FavoritesController";
import TakPage from "./_Web/pages/TakPage/TakPage";
import BuilderIo from "./builder.io";
import { SearchProvider } from "./_Web/hooks/useSearch";
import NewModal from "./_Web/components/Modal/NewModal";

// USING https://react-bootstrap.netlify.app/

export const IS_PRODUCTION = process.env.REACT_APP_ENV === "production";
export const SHOULD_DISPLAY_VERSION =
  !!process.env.REACT_APP_SHOULD_DISPLAY_VERSION;

if (IS_PRODUCTION) initTagManager();

(async () => {
  UserController.setBearerToken();

  initCookies();
  await initAxios();
  await initi18next();

  try {
    const user = await UserController.initLoggedUser();
    if (user) await OrderController.initPendingOrders();
    if (user) await OfferController.initPendingOffers();
    if (user) await FavoritesController.initUserFavoritesIds(user._id);
  } catch (error) {
    apiErrorToast(error);
  }

  const params = new URL(window.location.toString()).searchParams;
  const token = params.get("resetPasswordToken");
  if (token) openAuthModal();
})();

function HandleResizeDbounced() {
  const dispatch = useAppDispatch();

  const handle = () => {
    dispatch(setResizeHook(new Date().getTime()));
  };

  const handleCallback = useRef(debounce(handle, 150));

  useEffect(() => {
    window.addEventListener("resize", () => handleCallback.current());
    window.addEventListener("load", () => handle());

    setTimeout(() => handle(), 1000);
    setTimeout(() => handle(), 3000);
  }, []);

  return <></>;
}

function IndexRouter() {
  return (
    <Routes>
      {/* <Route path="test" element={<Test />} /> */}
      <Route path="app" element={<Redirect to="/" />} key="app-route" />
      <Route path="/tak/:id" element={<TakPage />} key="tak-route" />
      <Route path="auth" element={<Web />} key="auth-route" />
      <Route path="/b/*" element={<BuilderIo />} key="builder-route" />
      <Route path="*" element={<Web />} key="default-route" />
    </Routes>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <SearchProvider>
        <GoogleOAuthProvider
          clientId={String(process.env.REACT_APP_GOOGLE_CLIENT_ID)}
        >
          <IndexRouter />
          <ToastContainer className="!z-[99999]" toastClassName="!z-[99999]" />
          <Modal />
          <NewModal />
          <CookiesBanner />
          <HandleResizeDbounced />
          {SHOULD_DISPLAY_VERSION && (
            <div className="fixed bottom-4 right-4 bg-black text-white shadow-lg rounded-md py-2 px-3 text-sm">
              1.0.9
            </div>
          )}
        </GoogleOAuthProvider>
      </SearchProvider>
    </Provider>
  </BrowserRouter>,
);
